import React from 'react'
import { CostItem, EstimatedFees, EstimatedProfit } from '../components/CostItem'

export type Props = {
  includeFeesValue: boolean
  cost?: number
  unitProfit: number
  feesValue: number
}

export const ManualPricing = ({ includeFeesValue, cost, unitProfit, feesValue }: Props) => {
  return (
    <div>
      {cost && <CostItem name="Manufacturing costs" value={cost} negative />}
      {includeFeesValue && <EstimatedFees value={feesValue} />}
      <EstimatedProfit value={unitProfit} />
    </div>
  )
}
